import { Component, Input } from '@angular/core';

import * as _ from 'lodash';

@Component({
    selector: 'trove-content',
    template: require('./trove.content.component.html')
})
export class TroveContentComponent {

    @Input() category: any = null;

    // user => profile
    @Input() readOnly: any = null;

    protected YesNoChoices = {
        'Yes': 0,
        'No': 99
    };

    protected ShowInSearchChoices = {
        'Yes': 'Y',
        'No': 'N'
    };

    setConfigValue(path, value) {
        if (value == undefined || value == _.get(this, path)) return false;
        _.set(this, path, value);
    }
}